import xw from 'xwind';
import styled from '@emotion/styled';

export const Wrapper = styled.div(
  xw`relative bg-gray-100 w-full h-full rounded-3xl overflow-hidden`,
);

export const Container = styled.div(
  xw`w-full h-full flex justify-center items-center`,
);

export const ImageContainer = styled.div(xw`relative w-full`);

export const StarOutlineIconContainer = styled.div(
  xw`w-6 h-6 absolute top-3 right-3 sm[w-8 h-8 top-5 right-5]`,
);
